<template>
  <div class="container pt-6  justify-content-center" style="max-width: 600px">
    <div class="shadow bg-body rounder p-4">
      <h3 class="text-center mb-3">Вход в личный кабинет</h3>
      <form @submit="onSubmit">
        <div class="mb-3 row">
          <label for="email" class="col-sm-4 col-form-label">Email/Телефон</label>
          <div class="col-sm-7">
            <input
              id="email"
              class="form-control"
              v-model="form.email"
              type="text"
              required
              placeholder="Email или Телефон 79XXXXXXXXX"
              @input="status.success = true"
            />
          </div>
        </div>
        <div v-if="form.showCode" class="mb-3 row">
          <label for="code" class="col-sm-4 col-form-label">Код (последние 4 цифры)</label>
          <div class="col-sm-7">
            <input
              id="code"
              class="form-control"
              v-model="form.code"
              type="text"
              required
              placeholder=""
              @input="status.success = true"
            />
          </div>
        </div>
        <div class="mb-0 row">
          <div v-if="!form.showCode && !spinner" class="btn-group" role="group">
            <button type="submit" class="btn btn-primary">Вход или регистрация</button>
          </div>

          <div class="spinner-border text-primary text-center mt-3 container" role="status" v-if="spinner"></div>

          <div class=" mt-3 text-center">
            <span class=" text-danger" v-if="!status.success">
              <span class="text-center" v-if="status.err">
                {{ status.err }}
              </span>
              <span class="mt-3" v-if="status.err == ''"> Не верные имя или пароль </span>
            </span>
          </div>
        </div>
        <div class="mb-0 row">
          
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "LoginByCode",
  components: {},

  setup(props) {
    const store = useStore();
    const router = useRouter();
    const spinner = ref(false);

    const form = ref({
      email: "",
      code: "",
      showCode: false
    });
    const status = ref({
      success: true,
      err: ""
    });

    const onSubmit = async evt => {
      evt.preventDefault();
      spinner.value = true;
      status.value = await store.dispatch("registerByCode", form.value);
      if (status.value.success) {
        form.value.showCode = true;
        // router.push({ name: "home" });
        // document.location.reload(true);
      }
      spinner.value = false;
    };

    watch(form.value, async () => {
      if (form.value.code.length === 4) {
        status.value = await store.dispatch("loginByCode", form.value);
        if (status.value.success) {
          await router.push({ name: "home" });
          document.location.reload(true);
        }
      }
    });

    return {
      status,
      store,
      form,
      onSubmit,
      spinner
    };
  }
};
</script>

<style scoped></style>
